/**
 * Extracts the number of miles from a distance string formatted as '{number}mi away' or '{number}km away'.
 *
 * @param {string} distanceString - The distance string to extract miles from, which can be in miles (mi) or kilometers (km).
 * @returns {number|null} - The extracted number of miles as an integer, or null if the input is invalid or the format is incorrect.
 */

export const extractMiles = (distanceString) => {
	if (typeof distanceString !== 'string') return null;
	const validDistanceString = distanceString
		.trim()
		.match(/^(\d{1,3}(,\d{3})*)(mi|km)\b/);
	if (!validDistanceString) return null;
	const length = parseInt(validDistanceString[1].replace(/,/g, ''), 10);
	const unitOfLength = validDistanceString[3];
	return unitOfLength === 'mi' ? length : Math.floor(length * 0.621371);
};
